export default "__VITE_PUBLIC_ASSET__a53221ba__"